export const Localization_zh_CN = {
    loadFailed: '加载失败.',
    setting: '设置',
    submit: '提交',
    numericalValueRequired: '数值不能为空',
    invalidNumericalValue: '数值格式不正确',
    binaryType: '二进制',
    decimalType: '十进制',
    hexadecimalType: '十六进制',
    stringType: '字符串',
    numericalValueTooLong: '数值超长',
    fractionDigitsMustLessThan: '小数位不能超过',
    canNotBeNegative: '不能为负数',
    valueOutOfRange: '数值超出范围',
    timeout: '超时',
    confirmOperationPrompt: '是否确认要执行此操作？',
    confirm: '确定',
    cancel: '取消',
    characterInputRequired: '请输入至少一个字符',
    character: '(字符串)',
    characterOutofRange: '字符长度超限',
    writeValueRange: '写值范围',
    loading: '加载中',
    unbind: '未绑定',
    offline: '离线',
    abnormal: '数据异常',
    disable: '禁用',
    permissiontip: '您无权限执行此操作',
    conditionIsNotMetTip: '操作条件不满足或逻辑控制变量异常',
    chartNoData: '无数据',
    lastOneHour: '最近1小时',
    lastTwentyFourHours: '最近24小时',
    lastSevenDays: '最近7天',
    lastThirtyDays: '最近30天',
    lastOneYear: '最近1年',
    grouped: '分组',
    stacked: '叠加',
    passwordVerify: '密码校验',
    passwordError: '密码错误',
    password: '密码',
    passwordToolTip: '密码错误，请重新输入',
    passwordRequired: '密码不能为空',
    invalidVideoAddress: '无效的视频地址',
    unconfiguredVideoAddress: '未配置视频地址',
    weatherNotSupport: '当前位置暂不支持',
    weatherNotAddress: '当前设备未设置地址',
    weatherNotAvailable: '暂未获取设备地址'
};
